import { Outlet } from 'react-router-dom';
import TicketHeader from '../TicketHeader/TicketHeader';

const TicketChat = () => {
  return (
    <div className="flex h-full w-full flex-col bg-neutral-1">
      <div className="box-border flex h-[76px] shrink-0 items-center justify-between gap-2 border-0 border-neutral-7 border-b border-solid p-4">
        <TicketHeader />
      </div>
      <div className="flex h-full flex-col bg-neutral-1">
        <Outlet />
      </div>
    </div>
  );
};

export default TicketChat;
